import { Field } from 'formik';
import { Checkbox as SvpCheckbox } from '@schibsted-svp/react-ui';

import type { FC } from 'react';
import type { FieldProps } from 'formik';

import styles from './Checkbox.module.scss';

type Props = {
  label: string;
  name: string;
  [key: string]: unknown;
};

const Checkbox: FC<Props> = ({ label, ...props }) => {
  return (
    <div className={styles.container}>
      <Field {...props}>
        {({ field, meta }: FieldProps) => (
          <SvpCheckbox
            {...field}
            {...props}
            checked={field.value}
            label={label}
            error={typeof meta.error === 'string' ? meta.error : undefined}
          />
        )}
      </Field>
    </div>
  );
};

export { Checkbox };
